// extracted by mini-css-extract-plugin
export default {"root":"KrWQf__root","msTeamsConnecting":"Amyfd__msTeamsConnecting"};